import { ActionTypes } from "./constants";

const setUsers = (payload) =>({ type: ActionTypes.SET_USERS, payload: payload });
const addUser = (payload) =>({ type: ActionTypes.ADD_USER, payload: payload });
const updateUser = (payload) =>({ type: ActionTypes.UPDATE_USER, payload: payload });
const updateUserApprove = (payload) =>({ type: ActionTypes.UPDATE_USER_IS_APPROVE, payload: payload });
const deleteUser = (payload) =>({ type: ActionTypes.DELETE_USER, payload: payload });

const exports = { 
    setUsers,
    addUser,
    updateUser,
    updateUserApprove,
    deleteUser
}

export default exports 
